import { TransactionType } from '../transactions.js';
export var isTransferTransaction = function (transaction) { return transaction.type === TransactionType.TRANSFER; };
//# sourceMappingURL=transfer.js.map